// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=f7c25b9d-c7b3-411f-9f7a-581b7ff047d3";
};